"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalWrapper = void 0;

var _stylitas = require("@creditas/stylitas");

var _styledTools = require("styled-tools");

var ModalWrapper = _stylitas.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: ", ";\n"])), (0, _styledTools.prop)('zIndex', 1000));

exports.ModalWrapper = ModalWrapper;